import { c as _c } from "react/compiler-runtime";
import type { RatingStats } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { MouseEvent } from "react";
import TopRaterAvatars from "./header/TopRaterAvatars";
const stopPropagation = (e: MouseEvent) => e.stopPropagation();
export default function RepCategoryPill(t0) {
  const $ = _c(37);
  const {
    rep,
    profileHandle,
    canEdit,
    onEdit,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const paddingClass = compact ? "tw-px-3 tw-py-2" : "tw-px-4 tw-py-2.5";
  let t2;
  if ($[0] !== rep.category) {
    t2 = <span className="tw-text-sm tw-font-medium tw-text-white tw-text-left">{rep.category}</span>;
    $[0] = rep.category;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== rep.rating) {
    t3 = formatNumberWithCommas(rep.rating);
    $[2] = rep.rating;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="tw-text-sm tw-font-medium tw-text-iron-400 tw-transition-colors group-hover:tw-text-iron-300">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t2}{t4}</span>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-xs tw-text-white/20">·</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== profileHandle || $[11] !== rep.category) {
    t7 = <span className="tw-pointer-events-none desktop-hover:tw-pointer-events-auto"><TopRaterAvatars handleOrWallet={profileHandle} category={rep.category} count={5} onAvatarClick={stopPropagation} /></span>;
    $[10] = profileHandle;
    $[11] = rep.category;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== rep.contributor_count) {
    t8 = formatNumberWithCommas(rep.contributor_count);
    $[13] = rep.contributor_count;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = rep.contributor_count === 1 ? "rater" : "raters";
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{t8}{" "}{t9}</span>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <span className="tw-inline-flex tw-items-center tw-gap-1.5">{t7}{t10}</span>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== rep.rater_contribution) {
    t12 = !!rep.rater_contribution && <><span className="tw-text-xs tw-text-white/20">·</span><span className="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">My Rate:{" "}<span className="tw-font-medium tw-text-primary-400">{formatNumberWithCommas(rep.rater_contribution)}</span></span></>;
    $[21] = rep.rater_contribution;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t5) {
    t13 = <>{t5}{t6}{t11}{t12}</>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t5;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const content = t13;
  const baseClasses = `group tw-inline-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-out ${paddingClass}`;
  if (canEdit) {
    let t14;
    if ($[27] !== onEdit || $[28] !== rep.category) {
      t14 = () => onEdit(rep.category);
      $[27] = onEdit;
      $[28] = rep.category;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    const t15 = `${baseClasses} tw-cursor-pointer hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-shadow-md`;
    let t16;
    if ($[30] !== content || $[31] !== t14 || $[32] !== t15) {
      t16 = <button type="button" onClick={t14} className={t15}>{content}</button>;
      $[30] = content;
      $[31] = t14;
      $[32] = t15;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    return t16;
  }
  const t14 = `${baseClasses} tw-cursor-default`;
  let t15;
  if ($[34] !== content || $[35] !== t14) {
    t15 = <div className={t14}>{content}</div>;
    $[34] = content;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}